import React from "react";
import {ColumnsEdit} from "types/models/column-table-edit";
import {FORMAT_TIME} from "types/enums";
const {INPUT, CURRENCY, DATE, NUMBER, LIST, COMBO_BOX, AUTO_COMPLETE} =
  FIELD_TYPE;
import {FIELD_TYPE} from "types/enums";
import {listGender} from "data/list";
import {formatToCurrencyTypeFloor} from "helper/common";
import {DataFormField} from "types/models/input-field-type";
const columns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    render: (value, record, index) => index + 1,
    show: true,
    align: "center",
    width: 40,
  },
  {
    type: INPUT,
    dataIndex: "id",
    key: "id",
    title: "",
    width: 0,
  },
  {
    type: AUTO_COMPLETE,
    key: "glassesId",
    dataIndex: "glassesId",
    width: 0,
    show: true,
  },
  {
    type: AUTO_COMPLETE,
    title: "Mã vật tư",
    key: "code",
    dataIndex: "code",
    show: true,
    align: "left",
    autoFocus: true,
    width: 120,
  },
  {
    type: AUTO_COMPLETE,
    title: "Số lô",
    key: "soLo",
    dataIndex: "soLo",
    show: true,
    align: "left",
    width: 300,
  },
  {
    type: AUTO_COMPLETE,
    title: "Tên vật tư",
    key: "glassesName",
    dataIndex: "glassesName",
    show: true,
    align: "left",
    width: 260,
  },
  {
    type: INPUT,
    title: "Đơn vị tính",
    key: "donViTInh",
    dataIndex: "donViTInh",
    show: true,
    align: "center",
    disabled: true,
    width: 80,
  },
  {
    type: INPUT,
    title: "Loại vật tư",
    key: "loaiVatTu",
    dataIndex: "loaiVatTu",
    show: true,
    align: "left",
    disabled: true,
    width: 120,
  },
  // {
  //   type: INPUT,
  //   title: "Mô tả sản phẩm",
  //   key: "moTa",
  //   dataIndex: "moTa",
  //   show: true,
  //   align: "left",
  //   disabled: true,
  //   width: 150,
  // },

  {
    type: NUMBER,
    title: "SL tồn",
    key: "tonKho",
    dataIndex: "tonKho",
    show: true,
    align: "left",
    disabled: true,
    width: 80,
  },
  {
    type: NUMBER,
    title: "SL bán",
    key: "soLuong",
    dataIndex: "soLuong",
    show: true,
    align: "right",
    width: 80,
  },
  {
    type: NUMBER,
    title: "SL hoàn trả",
    key: "soLuongHoanTra",
    dataIndex: "soLuongHoanTra",
    show: true,
    align: "right",
    disabled: false,
    width: 90,
  },
  {
    type: CURRENCY,
    title: "Đơn giá bán",
    key: "donGia",
    dataIndex: "donGia",
    show: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyTypeFloor(value)}</>;
    },
    width: 140,
  },

  {
    type: NUMBER,
    title: "VAT",
    key: "vat",
    dataIndex: "vat",
    show: true,
    align: "right",
    max: 100,
    width: 60,
  },

  {
    type: CURRENCY,
    title: "Thành tiền",
    key: "thanhTien",
    dataIndex: "thanhTien",
    show: true,
    align: "right",
    disabled: true,
    width: 200,
  },
  {
    type: NUMBER,
    title: "Miễn giảm (%)",
    key: "giamGiaPercent",
    dataIndex: "giamGiaPercent",
    show: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyTypeFloor(value)}</>;
    },
    width: 110,
  },
  {
    type: CURRENCY,
    title: "Miễn giảm",
    key: "giamGia",
    dataIndex: "giamGia",
    show: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyTypeFloor(value)}</>;
    },
    width: 200,
  },
  {
    type: CURRENCY,
    title: "Thành tiền hoàn trả",
    key: "tongTienHoanTra",
    dataIndex: "tongTienHoanTra",
    show: true,
    align: "right",
    disabled: false,
    width: 200,
  },

  {
    type: INPUT,
    title: "Ghi chú",
    key: "note",
    dataIndex: "note",
    show: true,
    align: "left",
    width: 90,
  },
  {
    title: "",
    dataIndex: "action",
    key: "action",
    align: "center",
    width: 40,
    fixed: "right" as any,
    show: true,
  },
];
let fieldsPay: DataFormField[] = [
  {
    type: CURRENCY,
    label: "Tổng GT đơn",
    name: "tongTien",
    disable: true,
  },
  {
    type: CURRENCY,
    label: "Số tiền miễn giảm",
    name: "giamGia",
  },

  {
    type: INPUT,
    label: "Lý do giảm giá",
    name: "lyDoGiamGia",
  },

  {
    type: CURRENCY,
    label: "Thành tiền",
    name: "thanhTien",
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Thanh toán",
    name: "paymentsName",
    rules: [{message: "Chưa chọn hình thức thanh toán", required: true}],
  },
  {
    type: INPUT,
    label: "Nhân viên bán hàng",
    name: "nvBanHang",
  },
];
export {columns, fieldsPay};
